import * as yup from 'yup'

export class VehicleCheckInComboPhotoDto {
  documentGuid?: string = undefined
  displayFileName?: string = undefined
    vehicleCheckInComboPhotoFile?: File = undefined
}

export const vehicleCheckInComboPhotoValidationSchema = yup.object({
  vehicleCheckInComboPhotoFile: yup.mixed().notRequired()
})
